import { BaseApi } from '@/core/api/base.api'
import { Room } from '@/core/api/room.api'
import { roomUserService } from '@/core/service/room.user.service'
import _ from 'lodash'
import { Role } from "@/core/api/util.api";
import moment from "moment";
import * as Bowser from "bowser";
import GrmObservable from "@/lib/gooroomee/utils/GrmObservable";

class RoomUserApi extends BaseApi {
  #userProfileUrlCacheData = {};
  #userPhoneCacheData = {};
  #userAgent = Bowser.getParser(window.navigator.userAgent);
  #grmObservable = new GrmObservable();

  constructor() {
    super()
    Room.User = this

    Room.ready(async e => {
    })
  }

  async init () {
    this._eventListen(this.#Events)

    let roomUserList = (await roomUserService.getRoomUserList()).data
    if(roomUserList.length === 1){
      if(roomUserList[0].userId === Room.getRoomData().me.userId){
        roomUserList[0].firstEnterUser = true;
        Room.getRoomData().me.firstEnterUser = true;
      }
    }

    roomUserList.forEach(ru => {
      ru.screenShare = !!ru.screenShare;
      ru.enterDate = new Date(ru.enterDate);
    })
    roomUserList.sort((a,b) => {
      let n = a.enterDate - b.enterDate;
      if(n !== 0){
        return n;
      }
      return a.userId.localeCompare(b.userId);
    });

    Room.addRoomData({
      roomUserList: roomUserList,
      roomUserObj: roomUserList.reduce((obj, ru) => {
        obj[ru.userId] = ru
        return obj
      }, {}),
    })

    // LMS 사용자 목록 조회
    if (Room.RoomInfo.useLmsAbsentees()) {
      try {
        let { data } = await Room.Lms.getLmsUserList();
        if (!Array.isArray(data)) {
          data = [ data ]
        }
        data = data.filter(lmsUser => {
          return !Room.getRoomData().roomUserObj[lmsUser.userId];
        });

        await Room.emit('room_lms_user_list_set', data);
      } catch (e) {
        console.error(e)
      }
    }

    this._readyComplete();
  }

  #Events = {
    room_user_enter: function(e) {
      let ru = e.data.roomUser
      if (this.isEnterObserverUser(ru)) {
        return;
      }
      ru.screenShare = !!ru.screenShare;
      ru.enterDate = new Date(ru.enterDate);

      let roomUser = this.getRoomUser(ru)
      if (roomUser) {
        _.merge(roomUser, e.data.roomUser)
      } else {
        let data = Room.getRoomData()
        data.roomUserList.push(ru)
        data.roomUserObj[ru.userId] = ru
        roomUser = ru;
      }

      if(this.isMe(ru)) {
        Room.getRoomData().me = roomUser
      }

      if(!isNaN(e.data.currJoinCnt) && e.data.currJoinCnt > 0){
        Room.getRoomData().room.currJoinCnt = e.data.currJoinCnt;
      }else{
        e.data.currJoinCnt = Room.getRoomData().roomUserList.length;
      }

      e.data.roomUser = _.cloneDeep(e.data.roomUser);
      Room.emit(e)
    },
    room_user_leave: function(e) {
      let roomUser = this.getRoomUser(e.data.userId)
      if (!roomUser) {
        return
      }

      // cache reset
      const key = roomUser.userId;
      delete this.#userProfileUrlCacheData[key];
      delete this.#userPhoneCacheData[key];

      let data = Room.getRoomData()
      delete data.roomUserObj[roomUser.userId]

      let idx = data.roomUserList.indexOf(roomUser)
      if (idx > -1) {
        data.roomUserList.splice(idx, 1)
      }

      if(!isNaN(e.data.currJoinCnt)){
        data.room.currJoinCnt = e.data.currJoinCnt;
      }else{
        e.data.currJoinCnt = data.roomUserList.length;
      }

      e.data.roomUser = roomUser;

      try{
        Room.emit(e)
      }finally{
        if(this.isMe(roomUser)){
          const {reason} = e.data;
          console.log('# disconnected room !! : reason[%s]', reason);
          Room.leaved({reason})
              .catch(e => {
                console.error('', e);
              });
        }
      }
    },
    room_user_kickRoomUser: async function(e) {
      try{
        Room.emit(e);
      }finally{
        await Room.leaved({reason: 'kick'})
            .catch(e => {
              console.error('', e);
            });
      }
    },
    room_user_kickAllRoomUser: function(e) {
      Room.emit(e);
    },
    room_changeUserDeviceStatus: async function(e) {
      const userId = e.data.userId;
      const deviceType = e.data.deviceType
      const deviceStatus = e.data.deviceStatus

      const roomUser = this.getRoomUser(userId);

      const key = `${deviceType}Status`;
      const ori = roomUser[key];
      roomUser[key] = deviceStatus;
      console.log('# room_changeUserDeviceStatus : userId[%s], isCh[%s], %s->%s',
        userId, ori !== deviceStatus,
        ori, '->', deviceStatus);

      if(this.isMe(roomUser)) {
        await Room.Call.changeUserDeviceStatus(deviceType, deviceStatus);
      }

      Room.emit(e)
    },
    room_changeUserDeviceStatusAll: function(e) {
      const deviceType = e.data.deviceType
      const deviceStatus = e.data.deviceStatus
      const roomUserList = Room.getRoomData().roomUserList;

      roomUserList.forEach(roomUser => {
        if (Room.User.hasSpeakerRole(roomUser)) {
          return;
        }

        // roomUser[`${deviceType}Status`] = deviceStatus

        // if (this.isMe(roomUser)) {
        //   Room.Call.changeUserDeviceStatus(deviceType, deviceStatus);
        // }

        this.#Events.room_changeUserDeviceStatus.call(this, {
          type: 'room_changeUserDeviceStatus',
          _oriType: e.type,
          data: {
            userId: roomUser.userId,
            deviceType, deviceStatus
          }
        })
      })
      // Room.emit(e)
    },
    room_changeUserRole: function (e) {
      const userId = e.data.userId
      const roleType = e.data.roleType
      const roleStatus = e.data.roleStatus

      const roomUser = this.getRoomUser(userId);
      roomUser.roomUserRole[roleType] = roleStatus

      if (this.isMe(roomUser)) {
        Room.Call.changeUserDeviceRole(roleType);
      }

      Room.emit(e)
    },
    room_changeUserRoleAll: function (e) {
      const roleType = e.data.roleType
      const roleStatus = e.data.roleStatus
      const roomUserList = Room.getRoomData().roomUserList;

      roomUserList.forEach((ru) => {
        const roomUser = this.getRoomUser(ru);
        if(!this.isSpeakerRole(ru)) {
          roomUser.roomUserRole[roleType] = roleStatus;
          if(this.isMe(roomUser)) {
            Room.Call.changeUserDeviceRole(roleType);
          }
        }
      })
      Room.emit(e)
    },
    room_changeUserNickname: function(e) {
      let {data:{nickname, userId}} = e;
      const roomUser = this.getRoomUser(userId);
      roomUser.nickname = nickname;
      Room.emit(e)
    },
    room_changeUserRoleId: function(e) {
      const {userId, roleId} = e.data;

      if(roleId === Role.SPEAKER){
        const speakerUser = Room.getRoomData().roomUserList.find(ru=>ru.roomUserRole.roleId === roleId)
        if(speakerUser)
          speakerUser.roomUserRole.roleId = Role.EMCEE
      }
      
      let ru = this.getRoomUser(userId);
      ru.roomUserRole.roleId = roleId;
      
      Room.emit(e)
      Room.trigger({...e, type: 'after_room_changeUserRoleId'})
    },
    room_user_setUserList: function(e) {
      const { roomUserList } = e.data
      roomUserList && roomUserList.forEach(ru => this.changeRoomUserRoomGroupId(ru.userId, ru.roomGroupId))

      Room.emit(e.type, {
        roomUserList: _.cloneDeep(roomUserList)
      })
    },
    room_user_requestSpeak: function(e) {Room.emit(e)},
    room_user_cancelRequestSpeak: function(e) {Room.emit(e)},
    room_user_confirmRequestSpeak: function(e) {Room.emit(e)},
    room_user_reqReEnter: function(e) {
      Room.emit('room_reload');
    },
    room_user_reqReEnterAll: function(e) {
      let termMs = 0;
      if(!e.data?.immediate){
        termMs = Math.random() * (100 * this.getRoomUserList().length);
        termMs = Math.min(termMs, 1000*60*3);
      }
      setTimeout(() => {
        Room.emit('room_reload');
      }, termMs)
    },
    room_user_changeNetworkStatus: function(e) {
      const { type, userId, data } = e;

      Room.emit(type, {
        roomUser: { userId },
        ...data
      })
    },
    room_user_changeUserStatus: function(e){
      const {userId, userStatus} = e.data;
      const roomUser = this.getRoomUser(userId);
      roomUser.userStatus = userStatus;

      Room.emit(e)
    },
  }

  getRoomUser(userId) {
    if (typeof userId === 'object') {
      userId = userId.userId
    }
    if (!userId) {
      return null
    }
    const roomUser = Room.getRoomData().roomUserObj[userId]
    return roomUser;
  }
  getSpeakerRoomUser() {
    return Room.getRoomData().roomUserList.find(roomUser => roomUser.roomUserRole.roleId === 'speaker');
  }
  getMe() {
    return Room.getRoomData().me;
  }


  getRoomUserList() {
    return Room.getRoomData().roomUserList.concat();
  }
  getRoomUserCount() {
    return Room.getRoomData().roomUserList.length;
  }

  getNickname(roomUser) {
    let ru = this.getRoomUser(roomUser);
    if(!ru){
      return '';
    }
    return ru.nickname || ru.username;
  }

  async getUserInfo(userId) {
    return (await roomUserService.getUserInfo(userId)).data
  }

  async getMyNickname(roomId) {
    return await roomUserService.getMyNickname(roomId)
  }
  hasSpeakerRole(roomUser){
    if(!roomUser) roomUser = Room.getRoomData().me
    return this.isSpeakerRole(roomUser)
  }

  hasEmceeRole(roomUser){
    if(!roomUser) roomUser = Room.getRoomData().me
    return this.isSpeakerRole(roomUser) || this.isEmceeRole(roomUser) || this.isOpener(roomUser)
  }
  
  isOpener(roomUser) {
    if(!roomUser) roomUser = Room.getRoomData().me
    
    if (typeof roomUser === 'string') {
      return roomUser.userId === roomUser
    }
    const {room} = Room.getRoomData();
    return  room.userId === roomUser.userId
  }

  isEnterObserverUser(roomUser) {
    if (roomUser.roomUserRole.roleId == 'obs') {
      if (this.isMe(roomUser)) {
        Room.getRoomData().me = roomUser;
      }
      return true;
    }

    return false;
  }

  isGRMAFCD (user) {
    let roomUser = user || this.getMe();
    if(typeof(roomUser) === 'string'){
      roomUser = this.getRoomUser(user);
    }
    if(!roomUser) return false;
    let chk = roomUser.userType === 'obs'
      || roomUser.roomUserRole?.roleId == 'obs'
        //&& (roomUser.groupId === this.info.superGroupId || roomUser.groupId === this.info.groupId);
    return chk;
  }

  isMe(roomUser) {
    if (!roomUser) return false
    const currentUser = Room.getRoomData().me
    if (typeof roomUser === 'string') {
      return currentUser.userId === roomUser
    }
    return currentUser.userId === roomUser.userId
  }

  isSpeakerRole(roomUser) {
    if (!roomUser) roomUser = Room.getRoomData().me
    return roomUser?.roomUserRole?.roleId === Role.SPEAKER
  }

  isEmceeRole(roomUser) {
    if (!roomUser) roomUser = Room.getRoomData().me
    return roomUser?.roomUserRole?.roleId === Role.EMCEE
  }

  isParticipantRole(roomUser) {
    if (!roomUser) roomUser = Room.getRoomData().me
    return roomUser?.roomUserRole?.roleId === Role.PARTICIPANT
  }

  getAbsenceRoomUserList() {
    return Room.getRoomData().absenceRoomUserList
  }

  changeRoomUserRoomGroupId(userId, roomGroupId) {
    let roomUser = Room.getRoomData().roomUserList[userId]
    if (roomUser) {
      roomUser.roomGroupId = roomGroupId
    }
    let me = Room.getRoomData().me
    if (me.userId == userId) {
      me.roomGroupId = roomGroupId
    }
  }

  resetAllRoomUserRoomGroupIdDefault(roomGroupId) {
    let me = Room.getRoomData().me
    let roomUserList = Room.getRoomData().roomUserList;
    if (roomGroupId) {
      if (!Array.isArray(roomGroupId)) {
        roomGroupId = [roomGroupId]
      }
      roomUserList = roomUserList.filter(roomUser => !!roomGroupId.find(rg => rg == roomUser.roomGroupId))
    }
    roomUserList.forEach(ru => {
      ru.roomGroupId = 'default'
      if (me.userId == ru.userId) {
        me.roomGroupId = 'default'
      }
    })
  }

  async changeUserDeviceStatus(userId, deviceType, deviceStatus) {
    if (typeof userId === 'object') {
      userId = userId.userId
    }

    if (deviceType === 'audiooutput') {
      deviceType = 'speaker';
    }

    if (this.isMe(userId)) {
      await Room.Call.changeUserDeviceStatus(deviceType, deviceStatus);
    }

    await roomUserService.changeUserDeviceStatus(
        userId,
        deviceType,
        deviceStatus
    )

    if(deviceType === 'speaker' && this.isMe(userId)){
      const me = this.getMe();
      me[`${deviceType}Status`] = deviceStatus;
    }
  }

  async changeUserDeviceStatusAll(deviceType, deviceStatus) {
    if (deviceType === 'audiooutput') {
      deviceType = 'speaker';
    }

    if (deviceType === 'speaker') {
      Room.emit('changeSpeakerStatus', {deviceStatus});
    }

    if (!this.isSpeakerRole()) {
      await Room.Call.changeUserDeviceStatus(deviceType, deviceStatus);
    }

    await roomUserService.changeUserDeviceStatusAll(deviceType, deviceStatus)
  }

  async changeUserRole(userId, roleType, roleStatus) {
    if (typeof userId === 'object') {
      userId = userId.userId
    }

    await roomUserService.changeUserRole(
        userId,
        roleType,
        roleStatus
    )
  }

  changeUserRoleAll(roleType, roleStatus) {
    // if(!this.isSpeakerRole()) {
    //   this.changeUserDeviceStatusAll(roleType, roleStatus)
    //   // Room.Call.changeUserDeviceStatus(roleType, roleStatus);
    // }

    roomUserService.changeUserRoleAll(
        roleType,
        roleStatus
    )
  }
  
  getRoomUserRole(roomUser){
    if(!roomUser){
      roomUser = this.getMe();
    }
    const {roomUserRole} = roomUser;
    
    if(Room.Call.isWebinarLive() && !this.hasSpeakerRole(roomUser)){
      return Object.assign({}, roomUserRole, {
        mic: false,
        camera: false,
        screen: false,
      })
    }
    if(Room.Call.isWebinarWall() && this.isEmceeRole(roomUser)){
      return Object.assign({}, roomUserRole, {
        mic: false,
        camera: false,
        screen: false,
      })
    }
    return Object.assign({}, roomUserRole)
  }

  async changeRoomUserNickname(userId, nickname) {
    if (typeof userId === 'object') {
      userId = userId.userId
    }

    await roomUserService.changeRoomUserNickname(userId, nickname)
  }

  async changeAllUserAuthStatus(type) {
    await roomUserService.changeAllUserAuthStatus(type)
  }

  async setUserNickname(userId, nickname) {
    if (typeof userId === 'object') {
      userId = userId.userId
    }

    await roomUserService.setUserNickname(userId, nickname)
  }

  async kickRoomUser(data) {
    await roomUserService.kickRoomUser(data);
  }

  async kickAllRoomUser() {
    await roomUserService.kickAllRoomUser();
  }

  async requestSpeak() {
    await roomUserService.requestSpeak();
  }

  async cancelRequestSpeak(reqSpeakId) {
    await roomUserService.cancelRequestSpeak(reqSpeakId);
  }

  async confirmRequestSpeak({reqSpeakId, userId, reject}) {
    await roomUserService.confirmRequestSpeak({reqSpeakId, userId, reject});
  }

  getRoomUserAttendanceList() {
    return roomUserService.getRoomUserAttendanceList().then(res => {
      return res.data;
    });
  }

  async getUserProfileUrl(userId) {
    if (!userId) return;

    if (typeof userId === 'object') {
      userId = userId.userId
    }

    const key = userId;
    let cache = this.#userProfileUrlCacheData[key];

    if(cache !== undefined){
      return cache;
    }

    return new Promise((resolve, reject) => {
      this.#grmObservable.getOrCreate(userId, async obs => {
        let res = await roomUserService.getUserProfileUrl(userId);
        let url = this.#userProfileUrlCacheData[key] = res.data.url;
        obs.complete(url);
      }).subscribe(
          resolve,
          reject,
          () => {}
      );
    });

  }

  async getUserPhone(userId) {
    if (!userId) {
      return;
    }

    if (typeof userId === 'object') {
      userId = userId.userId
    }

    const key = userId
    let cache = this.#userPhoneCacheData[key]

    if (!cache) {
      this.#userPhoneCacheData[key] = cache = await roomUserService.getUserPhone(userId)
        .then(res => {
          delete this.#userPhoneCacheData[key]

          return res.data.data
        })
        .catch(e => {
          console.error(e)
        })

      return cache
    }

    return cache
  }

  async getRoomUserRollBook() {
    try {
      let roomUserLogs =
        await roomUserService.getRoomUserRollBook()
          .then(res => {
            return res.data;
          })

      let roomUserRollBook = roomUserLogs.map(rul => {

        if (!rul.initEnterDate && !rul.lastLeaveDate) {
          rul.initEnterDate = '-'
          rul.lastLeaveDate = '-'
          rul.timeDiff = '-'
        } else if (!rul.lastLeaveDate) {
          rul.lastLeaveDate = '-'
          rul.timeDiff = '-'
          rul.initEnterDate = rul.initEnterDate.replace('T', ' ')
        } else {
          let initEnterDate = moment(rul.initEnterDate)
          let lastLeaveDate = moment(rul.lastLeaveDate)
          let diffMilliSec = moment.duration(lastLeaveDate.diff(initEnterDate)).asMilliseconds()
          rul.timeDiff = moment.utc(diffMilliSec).format('HH:mm:ss')
          rul.initEnterDate = rul.initEnterDate.replace('T', ' ')
          rul.lastLeaveDate = rul.lastLeaveDate.replace('T', ' ')
        }
        return rul
      })
      return roomUserRollBook;
    } catch (e) {
      console.error(e)
    }
  }

  async changeRoomUserRoleId(data) {
    await roomUserService.changeRoomUserRoleId(data);
  }

  async changeUserVideoQuality(userVideoQuality) {
    await roomUserService.changeUserVideoQuality(userVideoQuality);
  }

  async changeUserStatus (status) {
    await roomUserService.changeUserStatus(status);
  }

  async getSpeakerUser () {
    return await roomUserService.getSpeakerUser();
  }

  // User Agent
  userAgent() {
    return this.#userAgent;
  }

  isDesktop() {
    return this.userAgent().getPlatformType() === 'desktop';
  }

  isMobile() {
    return this.userAgent().getPlatformType() === 'mobile';
  }

  isTablet() {
    return this.userAgent().getPlatformType() === 'tablet';
  }

  isAndroid() {
    return this.userAgent().getOSName() === 'Android';
  }

  isIOS() {
    return this.userAgent().getOSName() === 'iOS';
  }

  isIOSTabletApp() {
    return (
      !!this.userAgent()._ua.match(/mysuni/gi)?.length &&
      this.isIOS() &&
      this.isTablet()
    );
  }

  isApp() {
    return (
      !!this.userAgent()._ua.match(/mysuni/gi)?.length &&
      (this.isAndroid() || this.isIOS()) &&
      this.isTablet()
    );
  }
  
}

export const RoomUser = new RoomUserApi()
